import { Box, Chip, TableBody, TableCell, TableRow } from '@material-ui/core';
// import InputSearch from 'components/Input/InputSearch';
import React from 'react';
import AppTable from './Component/Table/AppTable';
import AppColor from 'utilities/AppColor';
const headCells = [
    {
        id: "paymentGateway",
        numeric: "left",
        disablePadding: false,
        label: "label.paymentGateway",
        sort: false,
    },
    {
        id: "status",
        numeric: "left",
        disablePadding: false,
        label: "label.status",
        sort: false,
    }
];

const data = [
    {
        id: 1,
        paymentGateway: 'Stripe',
        status: 'In-use'
    }
];
const PaymentGatewayManagement = () => {
    return (
        <Box>
            {/* <Box my={3}>
                <InputSearch  />
            </Box> */}
            <AppTable
                headCells={headCells}
                rowCount={data.length}
            >
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell>{row.paymentGateway}</TableCell>
                            <TableCell>
                                <Chip
                                    style={{
                                        backgroundColor: AppColor.green,
                                        color: AppColor.white,
                                    }}
                                    label={row.status}  
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </AppTable>
        </Box>
    )
}

export default PaymentGatewayManagement;